import BaseStore from './base-store.js'
import StoreProxy from './store_proxy.js'
import {API2_TOPICS} from 'consts/api2.js'



import * as $utils from 'utils';
export class Topic extends BaseStore {
  constructor(values = {}) {
    super({
      id: undefined,
      name: undefined,
      tracker_focus: undefined,
      tracker_alerts: undefined,
      focus_on: undefined,
      shared_topic_id: undefined,
      created_at: undefined,
      signals: undefined,
      ...values
    })
  }

  get state_copy(){
    return $utils.object.deepCopy(this._state)
  }

  async doSave(rest, changed) {
    const to_write = {}
    for (const key of changed) to_write[key] = this._state[key]
    await rest.patch(`${API2_TOPICS}/${this.id}`, to_write)
  }

  async drop(userId = undefined) {
    if (userId) {
      await this._rest.delete(`${API2_TOPICS}/${this.id}?user_id=${userId}`)
      return
    }
    await this._rest.delete(`${API2_TOPICS}/${this.id}`)
  }
  update(next){
    for (const key in next) {
      if (key in this._state) {
        this._state[key] = next[key]
      }
    }
  }
}

class Topics extends BaseStore {
  constructor(values = {}) {
    super({
      topics: [],
      view_items: [],
      view_total: 0,
      total: 0,
      ...values
    })
  }

  async doLoad(rest, params) {
    const result = await rest.get(API2_TOPICS, params)
    const existing_ids = new Set(this._state.view_items.map(i => i.id))
    this._state.view_items = result.view_items.map(
      data => existing_ids.has(data.id)
        ? this._updateItem(data)
        : new Topic(data))
    this._state.view_total = result.view_total
    this._state.total = result.total
  }

  _updateItem(data){
    const topic = this.getTopic(data.id)
    if (topic) {
      topic.update(data)
    }
    return topic
  }
  getTopic(id) {
    return this._state.view_items.find(x => x.id === id)
  }
  deleteItem(id){
    this._state.view_items = this._state.view_items.filter(topic => topic.id !== id)
  }
  async loadTopic(id) {
    const json = await this._rest.get(`${API2_TOPICS}/${id}`)
    return new Topic(json)
  }
  async newTopic(params) {
    const data = await this._rest.put(API2_TOPICS, params)
    return new Topic(data)
  }
  async updateTopic(id, params, userId = undefined) {
    const url = userId ? `${API2_TOPICS}/${id}?user_id=${userId}` : `${API2_TOPICS}/${id}`
    await this._rest.patch(url, params)
  }
  async search(query) {
    return await this._rest.get(`${API2_TOPICS}/search?query=${encodeURIComponent(query)}`)
  }
}

const topics = StoreProxy(new Topics(), {array_prop: 'view_items'})
export default topics
